module.exports = __webpack_public_path__ + "img/services-maintenance-icon.39eb7f39.svg";